$(document).ready(function() {	
	/* Pop ups / modals
	----------------------------------------------------*/
	$('.popup-inline-responsive').magnificPopup({
		type: 'ajax',
		fixedContentPos: false,
		fixedBgPos: true,
		overflowY: 'auto',
		closeBtnInside: true,
		preloader: true,
		closeOnBgClick: false,
		midClick: true,
		removalDelay: 300,
		mainClass: 'dialog-slide-bottom',
		callbacks: {
			open: function() {
				var $mobileMenu = $('.mobile-menu');
				if ($mobileMenu.hasClass('open')) {
					$('.mobile-menu').trigger('click');
				}
			},
			close: function() {
				// Nothing here yet
			},
			ajaxContentAdded: function() {
				var $thisElm = $(this.container[0]);
				initializeComponents($thisElm);
				translateGUI($thisElm);
			}
		}
	});
	$(document).on('click', '.ct-btn-close-popup', function(e) {
		e.preventDefault();
		$.magnificPopup.close();
		setTimeout(function () {
			$(document.activeElement).blur();
		}, 400);
	});
	
	/* Try to open tab if hash exist in URL
	----------------------------------------------------*/
	var urlHash = window.location.hash;
	if (urlHash.match('#')) {
		$('.nav-tabs a[href=#'+urlHash.split('#')[1]+']').tab('show') ;
	} 
});